import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import averageIcon from '../images/icons/average.svg'
import euroIcon from '../images/icons/euro.svg'
import locationIcon from '../images/icons/location.svg'
import productionIcon from '../images/icons/production.svg'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'

const StatsScreen = props => {
  const menuItems = [
    {
      icon: locationIcon,
      title: 'Producción por finca y nave',
      goTo: 'statsByFarm',
    },
    {
      icon: productionIcon,
      title: 'Producción por producto',
      goTo: 'statsByProduct',
    },
    {
      icon: euroIcon,
      title: 'Facturación por producto',
      goTo: 'statsByProductPrice',
    },
    {
      icon: averageIcon,
      title: 'Precio medio por producto',
      goTo: 'statsByProductAveragePrice',
    },
  ]

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Estadísticas</Typography>
          </div>
          <div className="right" />
        </Toolbar>
      )}>
      <div className={props.classes.menu}>
        <Grid container>
          {menuItems.map((menuItem, idx) => (
            <Grid key={'itm' + idx} item xs={12} sm={6} md={4}>
              <div className={props.classes.menuItem} onClick={() => props.goTo(menuItem.goTo)}>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <img src={menuItem.icon} className={props.classes.menuItemIcon} />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography className={props.classes.menuItemTitle}>{menuItem.title}</Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <KeyboardArrowRightIcon />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </Page>
  )
}

const styles = {
  appBar: {
    background: '#1B458E',
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  menu: {},
  menuItem: {
    padding: 10,
    borderBottom: '1px solid #DDD',
    borderRight: '1px solid #DDD',
    textAlign: 'center',
    cursor: 'pointer',
  },
  menuItemIcon: {
    maxWidth: '50%',
    maxHeight: 30,
  },
  menuItemTitle: {
    fontSize: 20,
    textAlign: 'left',
  },
  menuItemBody: {
    fontSize: 12,
    textAlign: 'left',
  },
}

export default withStyles(styles)(StatsScreen)



// WEBPACK FOOTER //
// ./src/screens/StatsScreen.js